export default __webpack_public_path__ + "static/media/1.a166847d.png";